import { formConvertErrorMessage } from "helpers/form_helper";
import { errorMessage } from "helpers/utils";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery } from "react-query";
import { useToasts } from "react-toast-notifications";
import busService from "services/busService";

// List Bus
export const useListBus = (payload, onSuccess, onError, key) => {
  const { t } = useTranslation(["bus"]);
  const { addToast } = useToasts();

  const { params } = payload;

  return useQuery(
    [key || "buss", params?.page, params?.columnFilter, params?.keywords],
    () => busService.listBus(payload),
    {
      enabled: false,
      retry: 1,
      staleTime: 5 * 60 * 1000,
      cacheTime: 5 * 60 * 1000,
      initialData: {
        items: [],
        totalCount: 0,
        meta: null,
        params: params,
      },
      onSuccess,
      onError: error => {
        const errorResponse = errorMessage(error);
        addToast(
          formConvertErrorMessage(
            errorResponse.message ||
              t("message.list", {
                target: t("bus"),
                status: t("message.error"),
              }),
            t
          ),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        if (typeof onError === "function") {
          onError(errorResponse);
        }
      },
      select: response => {
        const { data } = response;
        return {
          items: data?.items || [],
          params: params,
          totalCount: data?._meta?.totalCount || data?.items?.length || 0,
          meta: data?._meta,
        };
      },
    }
  );
};

// Create Bus
export const useCreateBus = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["bus"]);
  const { addToast } = useToasts();

  return useMutation(busService.createBus, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.create", {
          target: t("bus"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.create", {
              target: t("bus"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

// Detail Bus
export const useDetailBus = (payload, onSuccess, onError) => {
  const { t, i18n } = useTranslation(["bus"]);
  const { addToast } = useToasts();

  return useQuery(["bus", "detail"], () => busService.detailBus(payload), {
    enabled: false,
    retry: 1,
    onSuccess,
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.detail", {
              target: t("bus"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
    select: response => {
      const { data } = response;
      return data;
    },
  });
};

// Update Bus
export const useUpdateBus = (onSuccess, onError) => {
  const { t, i18n } = useTranslation(["bus"]);
  const { addToast } = useToasts();

  return useMutation(busService.updateBus, {
    retry: 0,
    onSuccess: data => {
      addToast(
        t("message.update", {
          target: t("bus"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.update", {
              target: t("bus"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

// Active Bus
export const useActiveBus = (onSuccess, onError) => {
  const { t } = useTranslation(["bus"]);
  const { addToast } = useToasts();

  return useMutation(busService.updateBus, {
    retry: 0,
    onSuccess: response => {
      const { data } = response;

      addToast(
        t("message.active", {
          target: t("bus"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.active", {
              target: t("bus"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};

// Delete Bus
export const useInactiveBus = (onSuccess, onError) => {
  const { t } = useTranslation(["bus"]);
  const { addToast } = useToasts();

  return useMutation(busService.updateBus, {
    retry: 0,
    onSuccess: response => {
      const { data } = response;

      addToast(
        t("message.delete", {
          target: t("bus"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      const errorResponse = errorMessage(error);
      addToast(
        formConvertErrorMessage(
          errorResponse.message ||
            t("message.delete", {
              target: t("bus"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      if (typeof onError === "function") {
        onError(errorResponse);
      }
    },
  });
};
